var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vxe-grid',_vm._b({attrs:{"data":_vm.tableData,"columns":_vm.tableColumns,"resizable":""},scopedSlots:_vm._u([{key:"spec",fn:function(ref){
var row = ref.row;
return [_vm._v(" "+_vm._s(row.spec)+" "+_vm._s(row.specUnit)+" ")]}},{key:"isGroup",fn:function(ref){
var row = ref.row;
return [_c('el-tag',{attrs:{"size":"mini","type":row.isGroup === 'Y' ? 'light' : 'info'}},[_vm._v(" "+_vm._s(row.v_isGroup)+" ")])]}}])},'vxe-grid',_vm.gridOptions,false))}
var staticRenderFns = []

export { render, staticRenderFns }